export enum ThirdPartyType {
  None = 'none',
  Resman = 'resman',
  RealPage = 'realpage',
  Yardi = 'yardi',
  Entrata = 'entrata',
  RentManager = 'rentmanager',
}
